<div class="qr-container" #canvasContainer>
  @if (dataUrl()) {
    <img [src]="dataUrl()" alt="" draggable="false" />
  }
</div>
